/**
 * @file: trialCountdown.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import dayjs from 'dayjs';

/**
 * How near a trial's end is: `far` past a week (show its date), `soon`
 * within a week, `urgent` within three days; by calendar days, 0 on its
 * last day.
 */
export type TrialCountdown =
  | { kind: 'far' }
  | { kind: 'soon' | 'urgent'; daysLeft: number };

export function trialCountdown(
  trialEndsAt: string,
  now: dayjs.ConfigType = undefined,
): TrialCountdown {
  const daysLeft = Math.max(
    0,
    dayjs(trialEndsAt).startOf('day').diff(dayjs(now).startOf('day'), 'day'),
  );
  if (daysLeft > 7) return { kind: 'far' };
  return { kind: daysLeft <= 3 ? 'urgent' : 'soon', daysLeft };
}
